import CHATCoinICon from 'assets/img/chat-coin.png'
import ckBTCCoinIcon from 'assets/img/ckBTC-coin.png'
import SNS1CoinIcon from 'assets/img/sns1-coin.png'
import ICPCoinIcon from 'assets/svg/icp-coin.svg'
import { ConstantsList } from 'constants/constants'
import { TokenLedgerModel } from 'entity/token-ledger.model'
import {
  CalendarIcon,
  ChatsIcon,
  FeedIcon,
  HelpIcon,
  ProfileIcon,
  SettingIcon,
} from './svg-icons'
import { FEED_TYPE } from 'services/konectaService'

export const checkIsUrl = (value: string) => {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value,
  )
}

export const preprendProtocolToUrl = (value: string) => {
  return value.startsWith('https://') ? value : `https://${value}`
}

export const faqs = [
  {
    question: 'How does KonectA work?',
    answer:
      'On Konecta, the user can decide which live event to attend based on their availability with a simple glance, however on YouTube or Instagram, you have to adapt to the live event, and it is difficult to know when your favorite creators are going to go live, as your subscriptions increase over time.',
  },
  {
    question: 'Different from other social networks',
    answer:
      'On Konecta, the user can decide which live event to attend based on their availability with a simple glance, however on YouTube or Instagram, you have to adapt to the live event, and it is difficult to know when your favorite creators are going to go live, as your subscriptions increase over time.',
  },
  {
    question: 'Is KonectA free to use?',
    answer: "yes, it's free,",
  },
  {
    question: 'Payment methods',
    answer:
      'On Konecta, the user can decide which live event to attend based on their availability with a simple glance, however on YouTube or Instagram, you have to adapt to the live event, and it is difficult to know when your favorite creators are going to go live, as your subscriptions increase over time.',
  },
  {
    question: 'Help and support',
    answer:
      'On Konecta, the user can decide which live event to attend based on their availability with a simple glance, however on YouTube or Instagram, you have to adapt to the live event, and it is difficult to know when your favorite creators are going to go live, as your subscriptions increase over time.',
  },
  {
    question: 'Data and statistics',
    answer:
      'On Konecta, the user can decide which live event to attend based on their availability with a simple glance, however on YouTube or Instagram, you have to adapt to the live event, and it is difficult to know when your favorite creators are going to go live, as your subscriptions increase over time.',
  },
]

export type EventType = 'request' | 'offer'

export const eventTypes = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M18.3334 4.99992C18.3334 4.08325 17.5834 3.33325 16.6667 3.33325H3.33341C2.41675 3.33325 1.66675 4.08325 1.66675 4.99992M18.3334 4.99992V14.9999C18.3334 15.9166 17.5834 16.6666 16.6667 16.6666H3.33341C2.41675 16.6666 1.66675 15.9166 1.66675 14.9999V4.99992M18.3334 4.99992L10.0001 10.8333L1.66675 4.99992"
          stroke="#BCBCC2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    type: 'request' as EventType,
    title: 'Service request',
    des: 'Looking for professional assistance? Submit your service request today and let our audience of experts handle your needs.',
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M13.3334 17.5V4.16667C13.3334 3.72464 13.1578 3.30072 12.8453 2.98816C12.5327 2.67559 12.1088 2.5 11.6667 2.5H8.33341C7.89139 2.5 7.46746 2.67559 7.1549 2.98816C6.84234 3.30072 6.66675 3.72464 6.66675 4.16667V17.5M3.33341 5.83333H16.6667C17.5872 5.83333 18.3334 6.57953 18.3334 7.5V15.8333C18.3334 16.7538 17.5872 17.5 16.6667 17.5H3.33341C2.41294 17.5 1.66675 16.7538 1.66675 15.8333V7.5C1.66675 6.57953 2.41294 5.83333 3.33341 5.83333Z"
          stroke="#BCBCC2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    type: 'offer' as EventType,
    title: 'Service offer',
    des: 'Are you an industry expert? Share your valuable expertise with others through a customized event.',
  },
]

export type EventCategory =
  | 'Entertainment'
  | 'Health'
  | 'Professional'
  | 'Educational'
  | 'Other'

export const categories: Array<{
  caption: EventCategory
  value: number
}> = [
  { caption: 'Entertainment', value: 78 },
  { caption: 'Health', value: 39 },
  { caption: 'Professional', value: 43 },
  { caption: 'Educational', value: 59 },
  { caption: 'Other', value: 136 },
]

export const AllCategories = categories.map((ca) => ca.caption)

export type Interest =
  | 'Music'
  | 'Fitness'
  | 'Jazz'
  | 'Yoga'
  | 'Meditation'
  | 'Leadership'
  | 'Workshops'
  | 'School'
  | 'Lifelong learning'
  | 'Tutoring'

export const interests = [
  { caption: 'Music', value: 0 },
  { caption: 'Fitness', value: 0 },
  { caption: 'Jazz', value: 0 },
  { caption: 'Yoga', value: 0 },
  { caption: 'Meditation', value: 0 },
  { caption: 'Leadership', value: 0 },
  { caption: 'Workshops', value: 0 },
  { caption: 'School', value: 0 },
  { caption: 'Lifelong learning', value: 0 },
  { caption: 'Tutoring', value: 0 },
]

export const eventLocationLinkRegexp =
  /(https:\/\/(.*\.)?zoom.us\/[a-z]\/.+?\b)|(https:\/\/meet.google.com\/[a-zA-Z0-9-]{2,})|(https:\/\/teams.microsoft.com\/l\/meetup-join\/\S+)/gm

export const interests2 = [
  {
    category: 'Entertainment',
    values: [
      'Talks and debates on current affairs',
      'Video games',
      'Live concerts',
      'Ask Me Anything (AMAs)',
    ],
  },
  {
    category: 'Educational',
    values: [
      'Web development and programming courses',
      'Digital marketing and social media training',
      'Languages and linguistic skills',
      'Graphic design and multimedia training',
      'Business administration and management',
      'Blockchain',
      'Artificial Intelligence',
    ],
  },
  {
    category: 'Health',
    values: [
      'Personal coaching and development',
      'Therapy and psychological counseling',
      'Tutoring and private classes',
    ],
  },
  {
    category: 'Professional',
    values: [
      'Business consulting and financial advice',
      'Job training services',
      'Professional development coaching',
      'Vocational guidance',
    ],
  },
]

export const languages = ['English', 'Spanish', 'Chinese']
export const participationTypes = [
  'Person-to-Person',
  'Person-to-Multiple-Persons',
]
export const participationTooltip = [
  'You have selected a Person-to-Person event: Only one person can join',
  'The event will be Person-to-Multiple-Persons: Several people can join',
]
export const priceCourses = ['cKBTC', 'ICP', 'FREE']
export const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombi',
  'Comoros',
  'Congo (Brazzaville)',
  'Congo',
  'Costa Rica',
  "Cote d'Ivoire",
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor (Timor Timur)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia, The',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, North',
  'Korea, South',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia and Montenegro',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
]
export const timezones = [
  'Africa/Abidjan',
  'Africa/Accra',
  'Africa/Addis_Ababa',
  'Africa/Algiers',
  'Africa/Asmara',
  'Africa/Bamako',
  'Africa/Bangui',
  'Africa/Banjul',
  'Africa/Bissau',
  'Africa/Blantyre',
  'Africa/Brazzaville',
  'Africa/Bujumbura',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/Conakry',
  'Africa/Dakar',
  'Africa/Dar_es_Salaam',
  'Africa/Djibouti',
  'Africa/Douala',
  'Africa/El_Aaiun',
  'Africa/Freetown',
  'Africa/Gaborone',
  'Africa/Harare',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Kampala',
  'Africa/Khartoum',
  'Africa/Kigali',
  'Africa/Kinshasa',
  'Africa/Lagos',
  'Africa/Libreville',
  'Africa/Lome',
  'Africa/Luanda',
  'Africa/Lubumbashi',
  'Africa/Lusaka',
  'Africa/Malabo',
  'Africa/Maputo',
  'Africa/Maseru',
  'Africa/Mbabane',
  'Africa/Mogadishu',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Niamey',
  'Africa/Nouakchott',
  'Africa/Ouagadougou',
  'Africa/Porto-Novo',
  'Africa/Sao_Tome',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Anguilla',
  'America/Antigua',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Aruba',
  'America/Asuncion',
  'America/Atikokan',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Blanc-Sablon',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Cayenne',
  'America/Cayman',
  'America/Chicago',
  'America/Chihuahua',
  'America/Costa_Rica',
  'America/Creston',
  'America/Cuiaba',
  'America/Curacao',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Dominica',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Fort_Nelson',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Godthab',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Kralendijk',
  'America/La_Paz',
  'America/Lima',
  'America/Los_Angeles',
  'America/Lower_Princes',
  'America/Maceio',
  'America/Managua',
  'America/Manaus',
  'America/Marigot',
  'America/Martinique',
  'America/Matamoros',
  'America/Mazatlan',
  'America/Menominee',
  'America/Merida',
  'America/Metlakatla',
  'America/Mexico_City',
  'America/Miquelon',
  'America/Moncton',
  'America/Monterrey',
  'America/Montevideo',
  'America/Montserrat',
  'America/Nassau',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Pangnirtung',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Port_of_Spain',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Sitka',
  'America/St_Barthelemy',
  'America/St_Johns',
  'America/St_Kitts',
  'America/St_Lucia',
  'America/St_Thomas',
  'America/St_Vincent',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Thunder_Bay',
  'America/Tijuana',
  'America/Toronto',
  'America/Tortola',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Arctic/Longyearbyen',
  'Asia/Aden',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Atyrau',
  'Asia/Baghdad',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Brunei',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Colombo',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Jakarta',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kathmandu',
  'Asia/Khandyga',
  'Asia/Kolkata',
  'Asia/Krasnoyarsk',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Phnom_Penh',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qostanay',
  'Asia/Qyzylorda',
  'Asia/Riyadh',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Tomsk',
  'Asia/Ulaanbaatar',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vientiane',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yangon',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faroe',
  'Atlantic/Madeira',
  'Atlantic/Reykjavik',
  'Atlantic/South_Georgia',
  'Atlantic/Stanley',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Currie',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Busingen',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Guernsey',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Istanbul',
  'Europe/Jersey',
  'Europe/Kaliningrad',
  'Europe/Kiev',
  'Europe/Kirov',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Minsk',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Saratov',
  'Europe/Simferopol',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Ulyanovsk',
  'Europe/Uzhgorod',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zaporozhye',
  'Europe/Zurich',
  'Indian/Antananarivo',
  'Indian/Chagos',
  'Indian/Christmas',
  'Indian/Cocos',
  'Indian/Comoro',
  'Indian/Kerguelen',
  'Indian/Mahe',
  'Indian/Maldives',
  'Indian/Mauritius',
  'Indian/Mayotte',
  'Indian/Reunion',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Chuuk',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Enderbury',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Funafuti',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Pacific/Marquesas',
  'Pacific/Midway',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Pohnpei',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Saipan',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'Pacific/Wake',
  'Pacific/Wallis',
]

export const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'San']
export const times = [
  '1 am',
  '2 am',
  '3 am',
  '4 am',
  '5 am',
  '6 am',
  '7 am',
  '8 am',
  '9 am',
  '10 am',
  '11 am',
  '12 pm',
  '1 pm',
  '2 pm',
  '3 pm',
  '4 pm',
  '5 pm',
  '6 pm',
  '7 pm',
  '8 pm',
  '9 pm',
  '10 pm',
  '11 pm',
]

export const menuItems = [
  {
    icon: <CalendarIcon />,
    router: '/calendar',
    title: 'Calendar',
  },
  {
    icon: <FeedIcon />,
    router: '/feeds',
    title: 'Feed',
  },
  // {
  //   icon: <ChatsIcon />,
  //   router: '/chats',
  //   title: 'My Chats',
  // },
  {
    icon: <ProfileIcon />,
    router: (userName: string) => `/profile/${userName}`, // TODO: dynamic logged in user id as params
    title: 'My Profile',
  },
  {
    icon: <HelpIcon />,
    router: '/help',
    title: 'Help',
  },
  // {
  //   icon: <SettingIcon />,
  //   router: '/settings',
  //   title: 'Settings',
  // },
]

export const walletItems = [
  {
    icon: <img src={ICPCoinIcon} alt="coin icon" />,
    coin: 'ICP',
    addr: '7,870.840',
  },
  {
    icon: <img src={SNS1CoinIcon} alt="coin icon" />,
    coin: 'SNS1',
    addr: '70,874,911.640',
  },
  {
    icon: <img src={ckBTCCoinIcon} alt="coin icon" />,
    coin: 'ckBTC',
    addr: '7,870.840',
  },
  {
    icon: <img src={CHATCoinICon} alt="coin icon" />,
    coin: 'CHAT',
    addr: '70,874,369,911.640 ',
  },
]

export type FeedTabsType = 'SERVICE_REQUEST' | 'SERVICE_OFFERS'
// | 'MY_REQUESTS'
// | 'MY_OFFERS'

export type FeedTabsSubCategories =
  | 'ON_THIS_WEEK'
  | 'RECENT'
  | 'ACTIVE'
  | 'HISTORY'

export interface FeedTabSubcategoryConfig {
  label: string
  value: FeedTabsSubCategories
  feedType: FEED_TYPE
}
export interface FeedTabConfig {
  label: string
  value: FeedTabsType
  subcategories: FeedTabSubcategoryConfig[]
}

export const FeedTabsConfig: Record<FeedTabsType, FeedTabConfig> = {
  SERVICE_REQUEST: {
    label: 'Service requests',
    value: 'SERVICE_REQUEST',
    subcategories: [
      { label: 'Future', value: 'ON_THIS_WEEK', feedType: 'FUTURE_REQUESTS' },
      { label: 'Recent', value: 'RECENT', feedType: 'PAST_REQUESTS' },
    ],
  },
  SERVICE_OFFERS: {
    label: 'Service offers',
    value: 'SERVICE_OFFERS',
    subcategories: [
      { label: 'Future', value: 'ON_THIS_WEEK', feedType: 'FUTURE_OFFERS' },
      { label: 'Recent', value: 'RECENT', feedType: 'PAST_OFFERS' },
    ],
  },
  // MY_REQUESTS: {
  //   label: 'My requests',
  //   value: 'MY_REQUESTS',
  //   subcategories: [
  //     { label: 'Active', value: 'ACTIVE' },
  //     { label: 'History', value: 'HISTORY' },
  //   ],
  // },
  // MY_OFFERS: {
  //   label: 'My offers',
  //   value: 'MY_OFFERS',
  //   subcategories: [
  //     { label: 'Active', value: 'ACTIVE' },
  //     { label: 'History', value: 'HISTORY' },
  //   ],
  // },
}

export const FeedTabs = Object.values(FeedTabsConfig)
